import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import styled from "styled-components";
import { MdPhoneAndroid } from "react-icons/md";
import { Flex } from "rebass/styled-components";
import { Body } from "../../text";

const StyledMobile = styled(MdPhoneAndroid)`
  position: relative;
  color: ${(props) => props.theme.colors.envy};
`;

export default function DownloadMobile({ hideIcon, ...props }) {
  return (
    <>
      <ShareButton
        justifyContent="center"
        alignItems="center"
        flex={false}
        target="_blank"
        onClick={() => {
          props.onClick();
        }}
        {...props}
      >
        <Flex alignItems="center" flexDirection="row" justifyContent="center">
          <StyledMobile size={24}></StyledMobile>
          <Body ml={3}>Mobile Clip</Body>
        </Flex>
      </ShareButton>
    </>
  );
}
